export default {
    valorContribuicaoHome: 0,
    user: null,
    auth: null,
    cartaoVigente: null,
    carrinho: [],
    confirmacaoPagamento: null,
    menu: {
        comum: [
            {
                id: 'index',
                label: 'Home',
                route: 'index',
                url: null,
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: null,
            },
            {
                id: 'produtos.contribuicao',
                label: 'Contribuição',
                route: 'produtos.contribuicao',
                url: null,
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: null,
            },
            {
                id: 'contato',
                label: 'Contato',
                route: 'contato',
                url: null,
                params: {},
                viewFooter: true,
                viewHeader: false,
                children: null,
            },
        ],
        logado: [
            // {
            //     id: 'pedidos',
            //     label: 'Pedidos',
            //     route: null,
            //     url: "#",
            //     params: {},
            //     viewFooter: false,
            //     viewHeader: true,
            //     children: [
            //
            //     ],
            // },
            {
                id: 'logoff',
                label: 'Sair',
                route: 'logoff',
                url: null,
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: null,
            },
        ],
        minha_carteira:[
            // {
            //     id: 'minha.carteira',
            //     label: 'Minha Carteira',
            //     route: 'minha.carteira',
            //     url: null,
            //     params: {},
            //     viewFooter: false,
            //     viewHeader: true,
            //     children: null,
            // },
        ],
        logado_filiado: [
            {
                id: 'area_filiado',
                label: 'Área do Filiado',
                route: null,
                url: '#',
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: [
                  {
                    label: 'Meu Perfil',
                    route: 'area.filiado',
                    url: null,
                    params: {},
                  },
                  {
                    label: 'Histórico',
                    route: 'meus.pedidos',
                    url: null,
                    params: {},
                  },
                  {
                    label: 'Controle de Contribuição',
                    route: 'controle.contribuicao',
                    url: null,
                    params: {},
                  },
                  {
                    label: 'Isenção',
                    route: null,
                    url: process.env.VUE_APP_ENDPOINT_URL + 'loja/isencao-contribuicao/pedir-isencao',
                    params: {},
                  },
                  {
                    label: 'Informes de Contribuição',
                    route: 'irrf',
                    url: null,
                    params: {},
                  },
                  {
                    label: 'Minha Carteira',
                    route: 'minha.carteira',
                    url: null,
                    params: {},
                  },
                  {
                    label: 'Declaração de valor',
                    route: null,
                    url: process.env.VUE_APP_ENDPOINT_URL + 'filiados/usuario/editar?tab=contribuicao',
                    params: {},
                  },
                ],
            },
        ],
        nao_logado: [
            {
                id: 'login',
                label: 'Login',
                route: null,
                //route: 'autenticacao',
                url: process.env.VUE_APP_ENDPOINT_URL + 'autenticacao/?logoff=1&return=' + location.href,
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: null,
            },
            {
                id: 'cadastro.pessoa.fisica',
                label: 'Cadastre-se',
                route: 'cadastro.pessoa.fisica',
                url: null,
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: null,
            },
            {
                id: 'filiese',
                label: 'Filie-se',
                route: null,
                url: process.env.VUE_APP_ENDPOINT_URL + 'autenticacao/filiacao',
                params: {},
                viewFooter: false,
                viewHeader: true,
                children: null,
            }
        ],
    },
}



// WEBPACK FOOTER //
// ./src/vuex/state.js